import { create } from "zustand";

/**
 * Эфемерный UI-стейт оболочки: шторка мобильного меню. Persist
 * здесь запрещён — это не пользовательская настройка, а состояние текущего
 * экрана (rules/frontend-state.md §2).
 *
 * Открытость меню аккаунта сюда не возвращать: шапок две (десктопная и
 * мобильная смонтированы одновременно), и общий флаг открывал оба поповера
 * разом — они гасили друг друга по фокусу.
 */
type UiState = {
	mobileNavOpen: boolean;
	setMobileNavOpen: (open: boolean) => void;
};

export const useUiStore = create<UiState>()((set) => ({
	mobileNavOpen: false,
	setMobileNavOpen: (mobileNavOpen) => set({ mobileNavOpen }),
}));
